"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ScrollBarAdapter = /** @class */ (function (_super) {
    __extends(ScrollBarAdapter, _super);
    function ScrollBarAdapter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ScrollBarAdapter.prototype.onResize = function () {
        try {
            var evt = new UIEvent('resize');
            window.dispatchEvent(evt);
        }
        catch (e) { }
    };
    ScrollBarAdapter.prototype.componentDidMount = function () {
        this.frame && this.frame.contentWindow && this.frame.contentWindow.addEventListener('resize', this.onResize, false);
    };
    ScrollBarAdapter.prototype.componentWillUnmount = function () {
        this.frame && this.frame.contentWindow && this.frame.contentWindow.removeEventListener('resize', this.onResize);
    };
    ScrollBarAdapter.prototype.render = function () {
        var _this = this;
        var styles = {
            height: '0px',
            margin: '0px',
            padding: '0px',
            overflow: 'hidden',
            borderWidth: '0px',
            position: 'absolute',
            backgroundColor: 'transparent',
            width: '100%'
        };
        return (React.createElement("iframe", { className: "ScrollBarAdapter", ref: function (node) { return _this.frame = node; }, style: styles }));
    };
    return ScrollBarAdapter;
}(React.Component));
exports.ScrollBarAdapter = ScrollBarAdapter;
